module.exports = __webpack_public_path__ + "static/media/android-2.8d4ae373.jpg";